<script>
  export let congressId;
  export let congressYear;
  export let congressDay1;
  export let congressDay2;
  export let congressMonth1;
  export let city = congressId >= 156 ? "Frankfurt" : null;

  export let headline = "Exklusiv für institutionelle Investoren";
</script>

{#if congressId < 178}
  <header class="group mb-4 mt-8 flex items-start justify-between uppercase tracking-wide">
    <div>
      <h1 class="mb-4 text-3xl text-theme-minor-600">
        Institutional Money<br />
        <span class="text-black">Kongress {congressYear || ""}</span>
      </h1>
      <p>
        {#if congressDay1 && congressDay2 && congressMonth1 && congressYear}
          <span class="text-theme-minor-600">{congressDay1}. & {congressDay2}. {congressMonth1} {congressYear}</span>
          {#if city}
            in {city}
          {/if}
          <br />
        {/if}
        {headline}
      </p>
    </div>
    <figure class="max-w-[160px] transition-transform duration-700 *:w-full lg:group-hover:translate-x-8">
      <img src="/_Resources/Static/Packages/Fpi.Presentation/Assets/DoubleChevron.svg" alt="" />
    </figure>
  </header>
{:else}
  <header>
    <h1 class="my-5 grid w-fit grid-cols-1 gap-x-2 text-3xl max-[392px]:grid-cols-1 md:text-5xl">
      <span>Der Pflichttermin <strong class="italic text-theme-minor-600">{congressYear}</strong></span>
      <span class="text-xl uppercase md:text-3xl"><span class="w-fit text-xl uppercase text-theme-minor-600 md:text-3xl">Institutional Money</span> Kongress</span>
    </h1>
  </header>
{/if}
